import { Table } from 'antd';

import { userTypeColumns } from './columns';
import { userTypes } from './roles';

const UserTypesTable = () => {
  return (
    <div style={{ overflowY: 'auto' }}>
      <Table
        dataSource={userTypes}
        columns={userTypeColumns}
        pagination={false}
        rowKey="key"
        size="small"
        style={{ width: '100%' }}
        rowClassName="text-sm"
      />
    </div>
  );
};

export default UserTypesTable;
